export const getCookie = (key:string) => {
    return document.cookie.split(';').reduce((prev, entry) => {
        const [cookieKey, cookieValue] = entry.split('=');
        return (cookieKey.trim() === key) ? cookieValue : prev;
    }, undefined);
}


// WEBPACK FOOTER //
// ./src/lib/utils/cookie.ts